import { render, staticRenderFns } from "./ContactLight.vue?vue&type=template&id=d0404f4c&"
import script from "./ContactLight.vue?vue&type=script&lang=js&"
export * from "./ContactLight.vue?vue&type=script&lang=js&"
import style0 from "./ContactLight.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports